export default "__VITE_ASSET__CiRWnVV0__"